import styled from '@emotion/styled';
import css from '@styled-system/css';
import * as PropTypes from 'prop-types';
import { variant } from 'styled-system';

import semanticColorVariant, {
  types,
} from '../../internal/styles/semanticColorVariant';
import sx from '../../internal/styles/sx';
import Card from '../Card';

const brandedVariant = variant({
  prop: 'type',
  variants: {
    branded: {
      borderColor: 'primary.50',
    },
  },
});

const HighlightedCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'type' && prop !== 'size',
})(
  css({
    border: 2,
  }),
  variant({
    prop: 'border',
    variants: {
      removeBottomBorder: {
        borderWidth: '2px 2px 0 2px',
      },
      removeTopBorder: {
        borderWidth: '0 2px 2px 2px',
      },
    },
  }),
  ({ type }) => {
    return type === 'branded'
      ? brandedVariant
      : semanticColorVariant((borderColor) => ({ borderColor }));
  },
  sx
);

HighlightedCard.propTypes = {
  type: PropTypes.oneOf(types).isRequired,
  sx: PropTypes.object,
};

export default HighlightedCard;
